
























import {Component, Prop, Vue} from 'vue-property-decorator'
const NotFoundContent = () => import('@/components/NotFoundContent.vue')

@Component({
  components: {
    NotFoundContent
  }
})
export default class OrderView extends Vue {
  @Prop({ default: false }) readonly notFound?: boolean
}
